/* registerIcons.js */

'use strict';
const IconRegistry = require('@gluenetworks/icon_registry').getInstance();

//Registering Icon (actions)
const actions = require('./rawicons/actions.icon.svg.js');
IconRegistry.registerIcon('game_editor.actions', actions);

//Registering Icon (views)
const views = require('./rawicons/views.icon.svg.js');
IconRegistry.registerIcon('game_editor.views', views);
